import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 truncate" }
const _hoisted_2 = ["title", "textContent"]
const _hoisted_3 = ["title", "textContent"]

import { computed, toRefs } from 'vue';
import { AccountPresenter } from '@/models';
import { getAccountRoute } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    presenter: null,
    name: null,
    publicKey: null,
    disabled: { type: Boolean }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
  presenter?: AccountPresenter,
  name?: string,
  publicKey?: string,
  disabled?: boolean,
}




const {
  presenter, name, publicKey, disabled,
} = toRefs(props);

const effectiveName = computed(() => name?.value ?? presenter?.value?.name ?? 'Account Not Found');
const effectivePublicKey = computed(() => publicKey?.value ?? presenter?.value?.account.publicKey ?? '');
const effectiveDisabled = computed(() => disabled?.value || !effectivePublicKey?.value);

return (_ctx: any,_cache: any) => {
  const _component_account_icon = _resolveComponent("account-icon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(effectiveDisabled) ? 'div' : 'router-link'), {
    class: _normalizeClass(["flex space-x-4 p-4 bg-blue-50/60 bg-gradient-to-br from-white/50 to-blue-100/50 rounded-xl backdrop-blur-lg border border-blue-50", _unref(effectiveDisabled) ? 'cursor-not-allowed' : 'hover:border-indigo-500 hover:shadow-xl hover:shadow-purple-500/10 hover:from-white/50 hover:to-blue-200/50 transition cursor-pointer']),
    to: _unref(getAccountRoute)(_unref(effectivePublicKey)),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(effectiveDisabled) ? false : emit('click', $event)))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "icon", {}, () => [
        _createVNode(_component_account_icon, { presenter: _unref(presenter) }, null, 8, ["presenter"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          class: "text-black text-lg font-semibold leading-tight truncate",
          title: _unref(effectiveName),
          textContent: _toDisplayString(_unref(effectiveName))
        }, null, 8, _hoisted_2),
        _createElementVNode("p", {
          class: "text-gray-500 text-sm truncate leading-tight",
          title: _unref(effectivePublicKey),
          textContent: _toDisplayString(_unref(effectivePublicKey))
        }, null, 8, _hoisted_3)
      ])
    ]),
    _: 3
  }, 8, ["class", "to"]))
}
}

})